import { INTELLIGENT_PHOTO_CAPTURE_INITIALIZE_CONNECTION_REQUEST, INTELLIGENT_PHOTO_CAPTURE_INITIALIZE_CONNECTION_SUCCESS } from '../actions';
/**
 * Reducer for handling SignalR negotiation actions
 * @param state - Current photo capture state
 * @param action - Action containing the request/response data
 * @returns Updated state based on action type
 */
export const photoCaptureIntelligentInitializeDamageConnectionReducer = (state, action) => {
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_INITIALIZE_CONNECTION_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: false });
        case INTELLIGENT_PHOTO_CAPTURE_INITIALIZE_CONNECTION_SUCCESS:
            return Object.assign(Object.assign({}, state), { damageConnectionId: action.payload.connectionId });
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentInitializeDamageConnectionReducer.js.map